import React, { useState } from "react";
import styled from "styled-components";
import { useTheme } from "../../../../../hooks";
import { Icon } from "../../../../icon";
import { EnvIndicator } from "../env";
import NavItemContent from "../navItem/NavItemContent";
import { NavSignoutBarContainer, Permission, Username, UsernameContainer, UsernameDropdownItem, UsernameMenuDropdown, } from "./NavSignoutBarStyles";
const UsernameDropdownItemContent = styled(NavItemContent) `
  padding: 0.5rem 0.25rem;
`;
const NavSignoutBar = ({ username = "", links = [], displayEnvIndicator = false, displayPermissionsIndicator = false, permissions, env, isVertical = false, }) => {
    const { Theme } = useTheme();
    const [menuOpen, setMenuOpen] = useState(false);
    const openMenu = () => {
        setMenuOpen(true);
    };
    const closeMenu = () => {
        setMenuOpen(false);
    };
    return (React.createElement(NavSignoutBarContainer, { isVertical: isVertical },
        displayEnvIndicator && React.createElement(EnvIndicator, { env: env }),
        displayPermissionsIndicator && !!permissions?.length && (React.createElement(Permission, { isVertical: isVertical }, permissions)),
        !!username && (React.createElement(UsernameContainer, { onMouseOver: openMenu, onMouseLeave: closeMenu },
            React.createElement(Username, { isVertical: isVertical }, username),
            !!links?.length && (React.createElement(Icon, { iconName: "fa-angle-down", styles: {
                    color: Theme.nav[isVertical ? "vertical" : "horizontal"].username.color,
                    hoverColor: Theme.nav[isVertical ? "vertical" : "horizontal"].username.color,
                } })),
            menuOpen && (React.createElement(UsernameMenuDropdown, { isVertical: isVertical }, links?.map((link) => (React.createElement(UsernameDropdownItem, { key: link.name, isVertical: isVertical },
                React.createElement(UsernameDropdownItemContent, { ...link }))))))))));
};
export default NavSignoutBar;
//# sourceMappingURL=NavSignoutBar.js.map